import { defineAction } from 'redux-define'

const states = ['FULFILLED', 'REJECTED', 'CANCELLED']
export const namespace = 'property'

export const GET_PROPERTIES = defineAction('GET_PROPERTIES', states, namespace)
export const GET_PROPERTY_SEARCH_LIST = defineAction('GET_PROPERTY_SEARCH_LIST', states, namespace)
export const RESET_LIST_SEARCH_RESULTS = defineAction('RESET_LIST_SEARCH_RESULTS', states, namespace)

